import theme from "@/theme";
import { ChakraProvider } from "@chakra-ui/react";
import { CookiesProvider } from "react-cookie";
import { DndProvider } from "react-dnd";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HTML5Backend } from "../node_modules/react-dnd-html5-backend/dist/index";
import App from "./App";
import { Toaster } from "./Components/ui/toaster";
import { initGA, logPageView } from "./ga";
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

Sentry.init({
   dsn: "https://bc0a504e93edbd1429fd9e22028f6acc@o4508636369453056.ingest.de.sentry.io/4508636373778512",
   integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
   ],
   // Tracing
   tracesSampleRate: 1.0, //  Capture 100% of the transactions
   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
   tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
   // Session Replay
   replaysSessionSampleRate: 1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
initGA();
const domNode = document.getElementById("root");
const root = createRoot(domNode as HTMLElement);
root.render(
   <BrowserRouter>
      <CookiesProvider>
         <ChakraProvider theme={theme}>
            <DndProvider backend={HTML5Backend}>
               <QueryClientProvider client={queryClient}>
                  <App />
                  <Toaster />
               </QueryClientProvider>
            </DndProvider>
         </ChakraProvider>
      </CookiesProvider>
   </BrowserRouter>
);

logPageView();
